import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a7e5dbf2")

_pushScopeId("data-v-a7e5dbf2")
const _hoisted_1 = { class: "flex-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_steps, {
      class: "steps",
      simple: _ctx.simple,
      space: 400,
      style: {width: _ctx.width}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_step, {
          onClick: _ctx.preSelect,
          title: _ctx.titles.preSelect,
          status: _ctx.status.preSelect
        }, null, 8, ["onClick", "title", "status"]),
        _createVNode(_component_el_step, {
          onClick: _ctx.crop,
          title: _ctx.titles.crop,
          status: _ctx.status.crop
        }, null, 8, ["onClick", "title", "status"])
      ]),
      _: 1
    }, 8, ["simple", "style"])
  ]))
})